import React from 'react';
import { Typography } from '@material-ui/core';
import { Section, SmSpace } from 'm2m.components';
import { ModalidadeAmortizacao, type InstrumentoFinanceiroApiResponse } from 'common/genericTypes';
import moment from 'moment';
import { percentualAmortizacaoDescriptions } from 'common/genericDescriptions';

interface Props {
  eventosFinanceiros: InstrumentoFinanceiroApiResponse;
}

export const DetalhesEventosFinanceiros: React.FC<Props> = (props) => {
  const { eventosFinanceiros } = props;

  const sortedAmortizacoes = eventosFinanceiros.amortizacoes?.sort(
    (a, b) => +moment(a.dataAmortizacao) - +moment(b.dataAmortizacao)
  );
  const sortedPagamentoJurosDates = eventosFinanceiros.pagamentoJuros?.datas?.sort((a, b) => +moment(a) - +moment(b));
  const sortedIncorporacaoJurosDates = eventosFinanceiros.incorporacaoJuros?.datas?.sort(
    (a, b) => +moment(a) - +moment(b)
  );

  return (
    <>
      <Section title={'Pagamento de Amortização'}>
        <div>
          <Typography variant="body2">{'Percentual de Amortização sobre:'}</Typography>
          <Typography variant="body1">
            {percentualAmortizacaoDescriptions[eventosFinanceiros.amortizacaoSobre]}
          </Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">
            {
              'Percentual de Amortização passível de alteração e sujeito à disponibilidade de recursos previsto no Termo de Securitização?'
            }
          </Typography>
          <Typography variant="body1">
            {eventosFinanceiros.amortizacaoPassivelAoTermoSecuritizacao ? 'Sim' : 'Não'}
          </Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Modalidade de Amortização:'}</Typography>
          <Typography variant="body1">
            {eventosFinanceiros.modalidadeAmortizacao ?? ModalidadeAmortizacao.CUSTOMIZADO}
          </Typography>
          <SmSpace />
        </div>
        {sortedAmortizacoes?.length > 0 && (
          <div>
            <Typography variant="body2">{'Amortizações:'}</Typography>
            {sortedAmortizacoes.map((_, i) => (
              <Typography key={i} variant="body1">
                {_.percentualAmortizacao}
                {'%'}
                {' - '}
                {moment(_.dataAmortizacao).format('DD/MM/YYYY')}
              </Typography>
            ))}
            <SmSpace />
          </div>
        )}
      </Section>
      {sortedPagamentoJurosDates?.length > 0 && (
        <Section title={'Pagamento de Juros'}>
          <div>
            <Typography variant="body2">{'Data(s) Pagamento de Juros:'}</Typography>
            {sortedPagamentoJurosDates.map((data, i) => (
              <Typography key={i} variant="body1">
                {moment(data).format('DD/MM/YYYY')}
              </Typography>
            ))}
            <SmSpace />
          </div>
        </Section>
      )}
      {sortedIncorporacaoJurosDates?.length > 0 && (
        <Section title={'Incorporação de Juros'}>
          <div>
            <Typography variant="body2">{'Data(s) Incorporação de Juros:'}</Typography>
            {sortedIncorporacaoJurosDates.map((data, i) => (
              <Typography key={i} variant="body1">
                {moment(data).format('DD/MM/YYYY')}
              </Typography>
            ))}
            <SmSpace />
          </div>
        </Section>
      )}
      <Section title={'Resgate Antecipado Facultativo'}>
        <div>
          <Typography variant="body2">{'Apresenta Resgate Antecipado Facultativo?'}</Typography>
          <Typography variant="body1">{eventosFinanceiros.possuiResgateAntecipado ? 'Sim' : 'Não'}</Typography>
          <SmSpace />
        </div>
      </Section>
    </>
  );
};
